module.exports = __webpack_public_path__ + "img/Icon-klick-panonav.7ce90fd6.svg";